/*=========================================================================================
  File Name: getters.js
  Description: Ordering Getters
  ----------------------------------------------------------------------------------------
  Item Name: Ordering State Module
  Author: Tan Tran
==========================================================================================*/
import moment from 'moment'
import PriceCalculator from '../../../common/utils/PriceCalculator';
export default {

    initPickupTime : (state, getters, rootState) => {

        let estimatedPickupTime = moment();

        let currentWaitingTime = rootState.orderManager.currentWaitingTime;
        
        let fromTime = moment(rootState.openingHours.fromTime, 'HH:mm:ss');
        let toTime = moment(rootState.openingHours.toTime, 'HH:mm:ss');
        let currentTime = moment(rootState.openingHours.currentLocalTime, 'HH:mm:ss');

        if(fromTime == null) {
            fromTime = moment();
        }
        if(toTime == null) {
            toTime = moment();
        }

        //
        //Calculate estimated pickup time based on opening hours
        //
        if(currentTime  >= fromTime && currentTime < toTime) {
            estimatedPickupTime = currentTime;
        }
        else {
            if(currentTime < fromTime) {
                estimatedPickupTime = fromTime;
            }
            else {
                estimatedPickupTime = toTime;
                return estimatedPickupTime;
            }
        }
        estimatedPickupTime.add(currentWaitingTime, 'minutes');
        return estimatedPickupTime;
    },

    estimatedTime : (state, getters, rootState) => {
        
        let currentWaitingTime = rootState.orderManager.orderManagerState.currentWaitingTime;
        let maxWaitingTime = rootState.orderManager.orderManagerState.maxWaitingTime;
        let estimatedTimeFromCart = 0;
        state.cart.forEach(o => {
            estimatedTimeFromCart += (o.estimatedTime * o.quantity)
        });
        console.log(currentWaitingTime)
        if(estimatedTimeFromCart >= currentWaitingTime && estimatedTimeFromCart <= maxWaitingTime) {
            return estimatedTimeFromCart;
        }
        else if (estimatedTimeFromCart < currentWaitingTime){
            return currentWaitingTime;
        }
        else {
            return maxWaitingTime;
        }
    },

    totalItems : state => {
        let count = 0;

        state.cart.forEach(item => {
            count = count + item.quantity
        });

        return count;
    },

    amount : state => {
        let total = 0;
        state.cart.forEach(item => {
            console.log(item)
            let finalPrice = PriceCalculator.getProductPrice(item.price, item.addedPrice, item.discount);
            
            total += ( item.quantity * Math.round(finalPrice) );
        });
        return total;

    } 
}